import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import InlineCanvasChip from './InlineCanvasChip.vue'

export default Node.create({
  name: 'inline-canvas',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      timestamp: {
        default: null,
        parseHTML: element => element.getAttribute('timestamp'),
        renderHTML: attributes => ({ timestamp: attributes.timestamp }),
      },
      canvasId: {
        default: null,
        parseHTML: element => element.getAttribute('canvas-id'),
        renderHTML: attributes => ({ 'canvas-id': attributes.canvasId }),
      },
      imageSource: {
        default: null,
        parseHTML: element => element.getAttribute('image-source'),
        renderHTML: attributes => ({ 'image-source': attributes.imageSource }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'inline-canvas' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['inline-canvas', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(InlineCanvasChip)
  },
})
